import { IDBPDatabase, openDB } from "idb";
import { logger } from "@amzn/afxtaco-utilities";
import {
  TACO_DB_NAMES,
  TACO_DB_VERSION,
  TACO_IDB_DB,
  TACO_TABLE_NAMES,
} from "./DatabaseSchema";

let TACO_DB: IDBPDatabase<TACO_IDB_DB>;

const initializeDB = async () => {
  try {
    const TACO_IDB_DB_init = await openDB<TACO_IDB_DB>(
      TACO_DB_NAMES.TACO_IDB_DB,
      TACO_DB_VERSION.TACO_IDB_DB,
      {
        upgrade(db, oldVersion) {
          if (oldVersion < 1) {
            db.createObjectStore(TACO_TABLE_NAMES.SIMPLE_KVP);
          }
        },
      },
    );
    TACO_DB = TACO_IDB_DB_init;
  } catch (error) {
    logger.error({
      loggerMsg: JSON.stringify(error),
    });
  }
};

class TacoIDB {
  constructor() {
    initializeDB().catch((e) => {
      logger.error({
        loggerMsg: "Error initializing TacoIDB",
        e,
      });
    });
  }
}

// Instantiate DB immediately if file is bundled
new TacoIDB();

export const getTacoIDB = () => {
  if (TACO_DB === undefined) {
    initializeDB().catch((e) => {
      logger.error({
        loggerMsg: "Error retrieving TacoIDB",
        e,
      });
    });
  }

  return TACO_DB;
};
